const txtValidator = (value) => {
  return value && value.length > 0 ? true : "validate.txt_failed";
};

export { txtValidator };
